import type { DocMigration } from "../docMigration";

function annotationVisibleOnFloorPlan(ele: any) {
  return !(
    (ele.addToMechanicalPlan ||
      ele.addToPlumbingPlan ||
      ele.addToFoundationPlan ||
      ele.addToElectricalPlan ||
      ele.addToUtilityPlan ||
      ele.addToRoofPlan) &&
    !ele.addToFloorPlan
  );
}

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_175: DocMigration = {
  maxSchemaVersion: "0.0.175",
  description: "New annotation types (sales view and brochure)",
  apply(json: any) {
    const { viewerFilter, annotation } = json;
    if (viewerFilter) {
      viewerFilter["annotationSalesViewPlan"] = true;
      viewerFilter["annotationBrochurePlan"] = true;
    }

    if (annotation) {
      for (const annotationId in annotation) {
        const anno = annotation[annotationId];

        if (anno.type === "LINEWORK" && annotationVisibleOnFloorPlan(anno)) {
          anno.addToSalesViewPlan = true;
          anno.addToBrochurePlan = true;
        }
      }
    }

    return json;
  },
};

export default migration_0_0_175;
